module.exports = __webpack_public_path__ + "img/objective-1.5acbb460.jpg";